const cssClassesToApply = {
  basic: 'nhs-c-marker-basic',
  spotlight: 'nhs-c-marker-basic--spotlight',
  adult: 'nhs-c-marker-basic--adult',
  masterPlannedCommunity: 'nhs-c-marker-basic--mpc',
  selected: 'nhs-c-marker-basic--selected',
  viewed: 'nhs-c-marker-basic--viewed'
};

const getClassesToApply = ({
  isMasterPlannedCommunity,
  isSpotlight,
  isAdult,
  isSelected,
  isViewed
}) => {
  const classesToReturn = {
    base: [cssClassesToApply.basic],
    selected: [],
    viewed: []
  };

  if (isMasterPlannedCommunity) {
    const { masterPlannedCommunity } = cssClassesToApply;
    classesToReturn.base.push(masterPlannedCommunity);
  }

  if (isSpotlight) {
    const { spotlight } = cssClassesToApply;
    classesToReturn.base.push(spotlight);
  }

  if (isAdult) {
    const { adult } = cssClassesToApply;
    classesToReturn.base.push(adult);
  }

  if (isSelected) {
    const { selected } = cssClassesToApply;
    classesToReturn.selected.push(selected);
  }

  if (isViewed) {
    const { viewed } = cssClassesToApply;
    classesToReturn.viewed.push(viewed);
  }

  return classesToReturn;
};

export default getClassesToApply;
